import React, { FC } from 'react';
import { IconProps } from './IconInterface';

export const DashboardIcon: FC<IconProps> = ({ fill, width, height }: IconProps) => (
  <svg id="Layer_1" viewBox="0 0 32 32" width={width} height={height} fill={fill}>
    <path
      d="M11.4,18.7H2.7A2.8,2.8,0,0,1-.1,15.9V2.8A2.8,2.8,0,0,1,2.7,0h8.6a2.8,2.8,0,0,1,2.8,2.8V15.9A2.65,2.65,0,0,1,11.4,18.7ZM2.7,1.9a.79.79,0,0,0-.8.8V15.8a.79.79,0,0,0,.8.8h8.6a.79.79,0,0,0,.8-.8V2.8a.79.79,0,0,0-.8-.8H2.7Z"
      fill="current"
    />
    <path
      d="M29.2,10.7H20.6a2.8,2.8,0,0,1-2.8-2.8V2.8A2.8,2.8,0,0,1,20.6,0h8.6A2.8,2.8,0,0,1,32,2.8V7.9A2.73,2.73,0,0,1,29.2,10.7ZM20.6,1.9a.79.79,0,0,0-.8.8V7.8a.79.79,0,0,0,.8.8h8.6a.79.79,0,0,0,.8-.8v-5a.79.79,0,0,0-.8-.8H20.6Z"
      fill="current"
    />
    <path
      d="M11.4,32.1H2.7A2.8,2.8,0,0,1-.1,29.3V24.2a2.8,2.8,0,0,1,2.8-2.8h8.6a2.8,2.8,0,0,1,2.8,2.8v5.1A2.71,2.71,0,0,1,11.4,32.1ZM2.7,23.4a.79.79,0,0,0-.8.8v5.1a.79.79,0,0,0,.8.8h8.6a.79.79,0,0,0,.8-.8V24.2a.79.79,0,0,0-.8-.8Z"
      fill="current"
    />
    <path
      d="M29.2,32.1H20.6a2.8,2.8,0,0,1-2.8-2.8V16.1a2.8,2.8,0,0,1,2.8-2.8h8.6A2.8,2.8,0,0,1,32,16.1V29.2A2.76,2.76,0,0,1,29.2,32.1ZM20.6,15.3a.79.79,0,0,0-.8.8V29.2a.79.79,0,0,0,.8.8h8.6a.79.79,0,0,0,.8-.8V16.1a.79.79,0,0,0-.8-.8Z"
      fill="current"
    />
  </svg>
);
